import { __assign, __read, __rest } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/button/button.tsx
 */
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { noop } from "../../../_util/noop";
export var Button = React.forwardRef(function Button(_a, ref) {
    var _b;
    var formType = _a.formType, disabled = _a.disabled, _c = _a.hoverStartTime, hoverStartTime = _c === void 0 ? 20 : _c, _d = _a.hoverStayTime, hoverStayTime = _d === void 0 ? 70 : _d, _e = _a.hoverClass, hoverClass = _e === void 0 ? "button-hover" : _e, className = _a.className, _f = _a.onTouchStart, onTouchStart = _f === void 0 ? noop : _f, _g = _a.onTouchEnd, onTouchEnd = _g === void 0 ? noop : _g, _h = _a.onLongPress, onLongPress = _h === void 0 ? noop : _h, props = __rest(_a, ["formType", "disabled", "hoverStartTime", "hoverStayTime", "hoverClass", "className", "onTouchStart", "onTouchEnd", "onLongPress"]);
    var _j = __read(useState(false), 2), hover = _j[0], setHover = _j[1];
    var touchRef = useRef(false);
    var startTimerRef = useRef(null);
    var endTimerRef = useRef(null);
    var pressTimerRef = useRef(null);
    var startTimeRef = useRef(0);
    useEffect(function () {
        return function () {
            clearTimeout(startTimerRef.current);
            clearTimeout(endTimerRef.current);
            clearTimeout(pressTimerRef.current);
        };
    }, []);
    return (React.createElement("button", __assign({ ref: ref, 
        // eslint-disable-next-line react/button-has-type
        type: formType || "button", className: classNames("tea-core-button", className, (_b = {},
            _b[hoverClass] = hover && !disabled,
            _b)), onTouchStart: function (event) {
            if (disabled) {
                return;
            }
            onTouchStart(event);
            if (hoverClass) {
                touchRef.current = true;
                startTimerRef.current = setTimeout(function () {
                    if (touchRef.current) {
                        setHover(true);
                    }
                }, hoverStartTime);
            }
            pressTimerRef.current = setTimeout(function () {
                onLongPress(event);
            }, 350);
            startTimeRef.current = Date.now();
        }, onTouchEnd: function (event) {
            if (disabled) {
                return;
            }
            onTouchEnd(event);
            var spanTime = Date.now() - startTimeRef.current;
            if (spanTime < 350) {
                clearTimeout(pressTimerRef.current);
            }
            if (hoverClass) {
                touchRef.current = false;
                endTimerRef.current = setTimeout(function () {
                    if (!touchRef.current) {
                        setHover(false);
                    }
                }, hoverStayTime);
            }
        } }, props)));
});
//# sourceMappingURL=Button.js.map